<template>
    <div class="password-input" :style="cssVars">
        <input
            :type="passwordFieldType"
            :class="['totem-input', size, { 'squared': squared }, {'darkBorder': darkBorder }]"
            @input="handleInput"
            :disabled="disabled"
            :value="value"
            v-bind="$attrs"
        >
        <span :class="['input-icon', passwordIconClass]" @click="switchPasswordVisibility"></span>
    </div>
</template>

<script>
    export default {
        name: 'totem-password-input',
        props: {
            value: String,
            size: {
                type: String,
                validator: (prop) => ['small', 'medium', 'large'].includes(prop),
                default: 'medium'
            },
            width: {
                type: Number
            },
            squared: {
                type: Boolean,
                default: false
            },
            fullWidth: Boolean,
            disabled: {
                type: Boolean,
                default: false
            },
            darkBorder: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                passwordFieldType: 'password'
            }
        },
        methods: {
            handleInput($event) {
                this.$emit('input', $event.target.value)
            },
            switchPasswordVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            }
        },
        computed: {
            cssVars() {
                if (this.width != null) {
                    return {'--width': this.width + 'px'}
                } else if (this.fullWidth) {
                    return {'--width': '100%'}
                }
                return {'--width': '264px'}
            },
            passwordIconClass() {
                return this.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-blocked'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .password-input {
        position: relative;
        width: var(--width);
    }

    .totem-input {
        border: 1px solid $quill_gray;
        padding: 3px 45px 3px 15px;
        width: 100%;
        border-radius: 30px;

        &.small {
            font-size: 1.3rem;
            height: 30px;
        }

        &.medium {
            font-size: 1.6rem;
            height: 38px;
        }

        &:disabled {
            background: $alabaster;
        }

        &.squared {
            border-radius: 4px;
        }
        &.darkBorder {
            border-color: $silver_chalice;
        }
    }

    .input-icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 18px;
    }
</style>
